var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGerm3Turquoise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.59,
    height: 90.286,
    viewBox: "0 0 88.59 90.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 51.87,
    height: 74.787,
    fill: "#008996"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(92.59 -63.422) rotate(138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(82.599 -85.758)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M25.733,74.175a16.7,16.7,0,0,1-2.832-.242,17.758,17.758,0,0,1-12.768-9.89A26.007,26.007,0,0,1,7.924,56.4l-.036-.217C7.34,52.831,6.624,49.464,5.865,45.9A145.58,145.58,0,0,1,2.5,25.055C2.207,20.658,1.716,13.3,7.12,7.525a16.379,16.379,0,0,1,12.33-5.177,21.883,21.883,0,0,1,4.2.426A33.579,33.579,0,0,1,43.392,15.04a38.124,38.124,0,0,1,7.444,26.872A46.91,46.91,0,0,1,41.219,65.6c-5.382,7.084-11.392,8.572-15.486,8.572M19.449,4.584a14.194,14.194,0,0,0-10.7,4.469C4.011,14.122,4.462,20.871,4.731,24.9A143.788,143.788,0,0,0,8.053,45.435c.763,3.59,1.485,6.982,2.041,10.382l.036.218a24.107,24.107,0,0,0,2.013,7.029A15.521,15.521,0,0,0,23.28,71.73a14.551,14.551,0,0,0,2.453.209c3.588,0,8.878-1.334,13.705-7.688a44.668,44.668,0,0,0,9.173-22.556A35.867,35.867,0,0,0,41.626,16.41,31.32,31.32,0,0,0,23.22,4.967a19.668,19.668,0,0,0-3.771-.383",
    transform: "translate(-0.596 -0.598)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M27.262,71.232h0a12.3,12.3,0,0,1-2.071-.177,13.281,13.281,0,0,1-9.507-7.441,21.833,21.833,0,0,1-1.817-6.409l-.037-.222c-.564-3.446-1.292-6.865-2.061-10.486A142.052,142.052,0,0,1,8.492,26.285c-.262-3.909-.657-9.816,3.423-14.176a12.006,12.006,0,0,1,9.064-3.761,17.429,17.429,0,0,1,3.341.341,29.055,29.055,0,0,1,17.07,10.62,33.613,33.613,0,0,1,6.526,23.7,42.445,42.445,0,0,1-8.729,21.42c-4.272,5.624-8.843,6.8-11.925,6.8M20.978,10.584a9.823,9.823,0,0,0-7.431,3.052c-3.417,3.653-3.061,8.977-2.825,12.5a140.286,140.286,0,0,0,3.228,19.878c.78,3.666,1.513,7.111,2.086,10.61l.036.223a20.011,20.011,0,0,0,1.621,5.791,11.044,11.044,0,0,0,7.876,6.215A9.991,9.991,0,0,0,27.261,69c2.576,0,6.428-1.027,10.145-5.922A40.207,40.207,0,0,0,45.69,42.79a31.362,31.362,0,0,0-6.067-22.11,26.786,26.786,0,0,0-15.735-9.8,15.165,15.165,0,0,0-2.91-.3",
    transform: "translate(-2.125 -2.127)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M29.825,66.33a4.8,4.8,0,0,1-.817-.071A5.837,5.837,0,0,1,24.935,62.9a15.317,15.317,0,0,1-1.163-4.348l-.037-.227c-.593-3.626-1.375-7.3-2.131-10.852a135.969,135.969,0,0,1-3.126-19.14c-.254-3.8-.3-7.092,1.72-8.87,1.2-1.055,2.959-1.364,5.235-.915a21.494,21.494,0,0,1,12.619,7.875,26.1,26.1,0,0,1,5,18.407A35.01,35.01,0,0,1,35.8,62.467c-1.949,2.567-3.956,3.862-5.978,3.863M23.537,20.586a2.744,2.744,0,0,0-1.862.559c-1.357,1.2-1.131,4.575-.966,7.043a134.411,134.411,0,0,0,3.082,18.823c.761,3.578,1.548,7.277,2.151,10.956l.037.229a13.442,13.442,0,0,0,.967,3.729,3.623,3.623,0,0,0,2.443,2.131c1.407.242,2.967-.747,4.633-2.941a32.767,32.767,0,0,0,6.8-16.5A23.844,23.844,0,0,0,36.286,27.8,19.234,19.234,0,0,0,25,20.745a7.678,7.678,0,0,0-1.465-.159",
    transform: "translate(-4.676 -4.675)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M34.223,35.794h-.186a3.48,3.48,0,0,0-1.581.341c-.264.142-.686.459-.655.822.081.945,1.526,1.163,2.236,1.163h.186a3.482,3.482,0,0,0,1.581-.341c.264-.142.686-.459.655-.822-.081-.945-1.526-1.163-2.236-1.163",
    transform: "translate(-8.1 -9.118)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M35.223,59.044h-.186a3.48,3.48,0,0,0-1.581.341c-.264.142-.686.459-.655.822.081.945,1.526,1.163,2.236,1.163h.186a3.482,3.482,0,0,0,1.581-.341c.264-.142.686-.459.655-.822-.081-.945-1.526-1.163-2.236-1.163",
    transform: "translate(-8.355 -15.041)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M44.252,48.546A3.369,3.369,0,0,0,43.113,47.4c-.294-.151-.738-.345-1.046-.109a1.125,1.125,0,0,0-.34.995v.373a3.279,3.279,0,0,0,.566,1.515,3.376,3.376,0,0,0,1.139,1.148c.294.151.738.345,1.046.109a1.124,1.124,0,0,0,.339-.995v-.373a3.278,3.278,0,0,0-.565-1.515",
    transform: "translate(-10.63 -12.018)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M26.315,27.356c-.479,0-.42.743.059.743s.419-.743-.059-.743",
    transform: "translate(-6.619 -6.969)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M33.312,27.523c-.48,0-.413.742.064.742s.413-.742-.064-.742",
    transform: "translate(-8.402 -7.011)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M26.54,34.356c-.477,0-.538.743-.058.743s.538-.743.058-.743",
    transform: "translate(-6.662 -8.752)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M42.673,35.854a.373.373,0,0,0,.01.745.373.373,0,0,0-.01-.745",
    transform: "translate(-10.78 -9.133)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M36.19,48.021c-.48,0-.5.745-.024.745s.5-.745.024-.745",
    transform: "translate(-9.124 -12.233)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M42.7,60.632l-.124.124c-.34.339.193.862.532.522l.124-.124c.339-.34-.193-.862-.532-.522",
    transform: "translate(-10.817 -15.417)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M33.878,74.023c-.476,0-.549.742-.068.742s.549-.742.068-.742",
    transform: "translate(-8.529 -18.856)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M33.065,66.1l-.621-.621c-.338-.338-.887.167-.547.507l.622.621c.338.338.886-.167.546-.507",
    transform: "translate(-8.098 -16.651)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M38.936,67.518q-.186-.622-.372-1.242a.373.373,0,0,0-.712.22l.371,1.242a.373.373,0,0,0,.712-.22",
    transform: "translate(-9.638 -16.818)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M40.732,56.207l-.243-.5c-.21-.432-.852-.052-.643.376l.243.5c.21.432.852.052.643-.376",
    transform: "translate(-10.14 -14.142)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M44.219,42.067,43.1,41.694c-.455-.151-.626.574-.174.724l1.118.373c.455.152.626-.574.174-.724",
    transform: "translate(-10.867 -10.616)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M38.492,31.2l-.373-.373c-.338-.337-.908.142-.569.482l.373.373c.337.337.908-.143.569-.482",
    transform: "translate(-9.539 -7.823)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M33.016,31.582l-.994-.372c-.443-.165-.8.49-.35.658l.994.372c.443.165.8-.49.35-.658",
    transform: "translate(-8.015 -7.944)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M25.051,30.461l-.745-.248c-.454-.151-.718.546-.262.7l.745.248c.454.151.719-.546.262-.7",
    transform: "translate(-6.064 -7.691)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M29.74,51.2a2.9,2.9,0,0,1-1.136-.238,5.5,5.5,0,0,1-2.955-3.484,10.726,10.726,0,0,1-.307-4.153h0c.01-.114.015-.267.021-.443.042-1.2.1-2.849,1.217-3.5a2.077,2.077,0,0,1,1.707-.18,4.589,4.589,0,0,1,2.368,2.365c1.12,2.422,1.113,5.105,1.105,7.472a2.376,2.376,0,0,1-.259,1.211,1.933,1.933,0,0,1-1.762.949m-2.17-7.679h0a8.681,8.681,0,0,0,.212,3.286,3.33,3.33,0,0,0,1.706,2.1l.038.015a15.423,15.423,0,0,0-.9-6.417,3.176,3.176,0,0,0-.876-1.1A8.805,8.805,0,0,0,27.6,42.96c-.007.223-.015.417-.028.562",
    transform: "translate(-6.438 -9.96)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M40.4,84.424l-.124-.124c-.339-.339-.871.183-.531.522l.124.124c.34.34.871-.183.532-.522",
    transform: "translate(-10.096 -21.446)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M43.669,79.354a.373.373,0,0,0,.017.745.373.373,0,0,0-.017-.745",
    transform: "translate(-11.035 -20.214)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M48.612,72.188h-.124c-.481,0-.43.744.048.744h.124c.481,0,.43-.744-.048-.744",
    transform: "translate(-12.266 -18.389)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M19.841,61.857h-.124c-.474,0-.558.742-.078.742h.124c.474,0,.559-.742.078-.742",
    transform: "translate(-4.921 -15.757)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M15.922,41.691H15.8c-.478,0-.381.739.093.739h.124c.479,0,.382-.739-.092-.739",
    transform: "translate(-3.944 -10.62)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M17.222,19.524c-.475,0-.567.74-.088.74s.566-.74.088-.74",
    transform: "translate(-4.284 -4.974)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M22.71,14.356c-.475,0-.546.742-.065.742s.546-.742.065-.742",
    transform: "translate(-5.685 -3.657)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M34.04,17.189c-.478,0-.54.743-.06.743s.539-.743.06-.743",
    transform: "translate(-8.572 -4.379)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M48.305,28.114v.124c0,.477.739.376.739-.1v-.124c0-.478-.739-.376-.739.1",
    transform: "translate(-12.305 -7.057)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M54.223,54.776,54.1,54.9c-.338.338.152.9.492.56l.124-.124c.338-.338-.151-.9-.491-.56",
    transform: "translate(-13.752 -13.927)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M24.473,77.854h-.124a.373.373,0,0,0-.008.745h.124a.373.373,0,0,0,.009-.745",
    transform: "translate(-6.11 -19.832)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M51.3,66.74v.124a.373.373,0,0,0,.745-.018v-.124a.373.373,0,0,0-.745.018",
    transform: "translate(-13.068 -16.907)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M54.027,43.188c-.478,0-.512.745-.031.745s.512-.745.031-.745",
    transform: "translate(-13.667 -11.002)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M62.113,24.038c-.8,0-3.091,1.713-1.514,1.713.8,0,3.091-1.713,1.514-1.713",
    transform: "translate(-15.299 -6.123)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M53.7,12.627a2.767,2.767,0,0,0-1.95.639l-.248.248c-.474.474.345.722.7.728a2.767,2.767,0,0,0,1.95-.639l.249-.248c.474-.474-.345-.721-.7-.728",
    transform: "translate(-13.082 -3.216)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M9.111,72.033c-.5-.428-.728.306-.728.7v.124a2.662,2.662,0,0,0,.64,1.949c.5.428.728-.306.728-.7v-.124a2.666,2.666,0,0,0-.64-1.95",
    transform: "translate(-2.135 -18.316)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M32.759,97.842a3.158,3.158,0,0,0-1,.56c-.171.152-.452.385-.452.636v.248c0,.595.949.356,1.274.236a3.175,3.175,0,0,0,1-.56c.171-.152.452-.386.452-.637v-.248c0-.594-.949-.355-1.273-.236",
    transform: "translate(-7.974 -24.886)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M66.978,40.3c-.844,0,.417,2.568,1.333,2.568.844,0-.417-2.568-1.333-2.568",
    transform: "translate(-16.991 -10.265)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M3.78,42.333a2.723,2.723,0,0,0-.979,1.8v.248c0,.663.735.3,1.008.05a2.73,2.73,0,0,0,.979-1.8v-.248c0-.664-.735-.3-1.008-.05",
    transform: "translate(-0.714 -10.701)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M2.43,27.472H2.306c-.605,0-1.16.786-1.4,1.263-.121.241-.566,1.294.045,1.294h.124c.605,0,1.16-.786,1.4-1.262.121-.242.567-1.295-.045-1.295",
    transform: "translate(-0.162 -6.998)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M29.63,1.22C29.354.752,28.819,0,28.193,0h-.124c-.608,0-.139,1.068-.005,1.3.277.468.812,1.219,1.438,1.219h.124c.608,0,.139-1.068.005-1.295",
    transform: "translate(-7.073 0)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M42.25,4.574c-.891,0,.253,2.654,1.154,2.654S43.15,4.574,42.25,4.574",
    transform: "translate(-10.68 -1.165)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M13.771,4.461h-.124A2.576,2.576,0,0,0,11.9,5.533a1.776,1.776,0,0,0-.255.478,2.989,2.989,0,0,0-.474-.035c-1.3,0-2.7,1.282-.666,1.282a2.113,2.113,0,0,0,1.634-.722,2.59,2.59,0,0,0,1.736-1.07c.236-.317.573-1-.1-1",
    transform: "translate(-2.414 -1.136)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M4.539,51.1c-1.92,0,.309,1.371,1.246,1.371,1.921,0-.309-1.371-1.246-1.371",
    transform: "translate(-0.964 -13.017)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M7.777,61.541c-.948,0-1.225,2.951-.419,2.951.947,0,1.224-2.951.419-2.951",
    transform: "translate(-1.754 -15.677)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M18.2,91.257c-.159-.115-1.285-.78-1.285-.163v.124A2.194,2.194,0,0,0,17.941,92.8c.159.115,1.285.78,1.285.164v-.124A2.2,2.2,0,0,0,18.2,91.257",
    transform: "translate(-4.31 -23.139)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M50.024,90.567c-.141-.135-.366-.32-.577-.232s-.24.389-.24.573v.124a2.867,2.867,0,0,0,.814,1.944c.141.135.366.32.577.233s.24-.39.24-.574v-.124a2.868,2.868,0,0,0-.814-1.944",
    transform: "translate(-12.535 -23.006)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M55.832,81.819c-1.535,0,.9,1.543,1.687,1.543,1.535,0-.9-1.543-1.687-1.543",
    transform: "translate(-14.096 -20.842)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M15.154,86.991a3.157,3.157,0,0,0-1.206-.824c.537-.3-.611-2.538-1.466-2.538-.717,0,.075,1.842.89,2.406-.031,0-.062-.008-.092-.008h-.124c-.183,0-.486-.01-.591.194s.07.46.186.594a2.851,2.851,0,0,0,1.874.964h.124c.183,0,.486.01.591-.194s-.07-.46-.186-.593",
    transform: "translate(-3.108 -21.303)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M63.015,70.794c-.461.253-1.265.78-1.265,1.4v.124c0,.606,1.05.181,1.294.047.461-.253,1.265-.78,1.265-1.4v-.124c0-.606-1.05-.181-1.294-.047",
    transform: "translate(-15.73 -17.965)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M66.324,59.706c-.921,0,.139,2.705,1.027,2.705.921,0-.14-2.705-1.027-2.705",
    transform: "translate(-16.805 -15.209)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M68.951,52.534c-.133-.462-.4-1.278-.99-1.278h-.124c-.206,0-.3.42-.315.536a2.654,2.654,0,0,0,.1,1.066c.133.462.4,1.278.99,1.278h.124c.2,0,.3-.42.316-.536a2.681,2.681,0,0,0-.1-1.066",
    transform: "translate(-17.195 -13.057)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M66.158,31.93a3.163,3.163,0,0,0-.649-.949,1.12,1.12,0,0,0-.675-.392H64.71c-.6,0-.25,1.016-.119,1.289a3.163,3.163,0,0,0,.649.949,1.12,1.12,0,0,0,.675.392h.124c.6,0,.25-1.016.119-1.289",
    transform: "translate(-16.397 -7.792)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M5,14.958c-.042-.393-.183-1.429-.755-1.429H4.117c-.215,0-.352.325-.4.474a2.656,2.656,0,0,0-.089,1.066c.042.393.183,1.429.755,1.429H4.5c.214,0,.352-.325.4-.474A2.669,2.669,0,0,0,5,14.958",
    transform: "translate(-0.919 -3.446)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M19.27,2.539A2.66,2.66,0,0,0,17.53,1.45h-.124c-.649,0-.364.689-.112,1a2.662,2.662,0,0,0,1.739,1.088h.124c.648,0,.364-.689.112-1",
    transform: "translate(-4.333 -0.369)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M2.189,21.739a2.824,2.824,0,0,0-1.924.712l-.124.124c-.48.479.391.707.727.7a2.825,2.825,0,0,0,1.924-.712l.124-.124c.479-.48-.391-.708-.727-.7",
    transform: "translate(0 -5.538)",
    fill: "#008996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M27.462,97.448c-.933,0-3.182,1.35-1.269,1.35.933,0,3.182-1.35,1.269-1.35",
    transform: "translate(-6.482 -24.824)",
    fill: "#008996"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerm3Turquoise);
export default __webpack_public_path__ + "static/media/germ-3-turquoise.e95398936036f6807ff6f42070b25e8f.svg";
export { ForwardRef as ReactComponent };